<template>
    <el-dialog
      :title="title"
      :visible.sync="open"
      :append-to-body="true"
      :before-close="closePrompt"
      width="900"
      style="padding: 30px;"
    >
      <template v-if="promptText == 'refuse'">
        <div>
          <p>亲爱用户：</p>
          <p>未检测到录音设备，请检查一下您的麦克风是否正常！</p>
          <p>解决方法：</p>
          <p>1.请插上麦克风。</p>
          <p>2.用系统自带的麦克风录音看是否正常。</p>
          <p>3.系统麦克风正常以后,退出一下重新进入或者重新刷新一下.</p>
          <p>技术支持微信： ace998877abc</p>
        </div>
        <div class="en-box">
          <p>Dear User:</p>
          <p>
            No recording facility detected, please check if your microphone is
            working properly!
          </p>
          <p>Solution:</p>
          <p>1. Please plug in your microphone.</p>
          <p>2. Use the system microphone to record to see if it is normal.</p>
          <p>
            3. After the system microphone is normal, exit and re-enter or
            refresh.
          </p>
          <p>Technical support: ace998877abc</p>
        </div>
      </template>

      <template v-else-if="promptText == 'notFound'">
        <div class="zh-box">
          <p>亲爱用户：</p>
          <p>您尚未给我们网站录音权限.请给网站授权录音。</p>
        </div>
        <div class="en-box">
          <p>Dear User:</p>
          <p>
            You have not yet given us permission to record on our website.
            Please give the site permission to record.
          </p>
          <el-image :src="src" style="width: 300px"></el-image>
        </div>
      </template>
    </el-dialog>
  </template>

<script>
export default {
  data() {
    return {
      title: "未检测到录音设备 | No recording devices detected",
      // title: '录音未授权 | Unauthorised recording'
      src: require("@/assets/img/newUi-icon/file-read-1480.png"),
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    promptText: {
      type: String,
      default: "refuse",
    }
  },
  created() {
    console.log('====>log')
  },
  methods: {
    closePrompt() {
      this.$emit("update:open", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.en-box{
  margin-top: 20px;
}
.zh-box{
  margin-top: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/toefl/audio/components/prompt.vue